let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yryI"), load("7Creg"), load("lwh9U")]).then(() => parcelRequire('cR5Ec'));